module.exports = __webpack_public_path__ + "static/img/zoumadeng.cf86de5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zoumadeng.png
// module id = yagd
// module chunks = 1